import { Box } from '@material-ui/core';
import { SelectItemOverlay } from 'component/layout_quiz/select_item_overlay';
import { useEffect, useRef } from 'react';
import { useStyles } from './styles';

export const SkinToneItem = ({ item, index, handleSelectItem }) => {
    let itemRef: any = useRef();
    const classes = useStyles();

    useEffect(() => {
        if (itemRef && item.isSelect) {
            (itemRef as any).scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });
        }
    }, [itemRef, item.isSelect]);

    return (
        <div
            ref={(ref) => {
                itemRef = ref;
            }}
        >
            <Box
                style={{
                    border: `${item.isSelect ? '3px solid black' : '3px solid transparent'}`,
                    borderRadius: '8px',
                    backgroundColor: `${item.isSelect ? 'black' : 'transparent'}`,
                }}
            >
                <Box
                    className={classes.colorItem}
                    style={{
                        backgroundColor: `${item.bgColor}`,
                        borderRadius: '8px',
                        height: 50,
                        width: 95,
                    }}
                    onClick={() => handleSelectItem(item)}
                >
                    {item.isSelect && <SelectItemOverlay />}
                </Box>
                <p
                    className={classes.itemTitle}
                    style={{
                        color: item.isSelect ? '#F2F2F2' : '#1A1A1A',
                    }}
                >
                    {item.value}
                </p>
            </Box>
        </div>
    );
};
